import { env } from "../config/env";
import { createClient } from "./http";
import { getAuthToken } from "../pages/AdminAuth/components/authStore";

const api = createClient(env.CATALOG_BASE_URL);

export const IMPORT_V2_COLUMNS = [
  "product_sku",
  "product_name",
  "product_slug",
  "category_path",
  "main_category",
  "subcategory",
  "brand",
  "unit_symbol",
  "barcode",
  "short_description",
  "description",
  "tax_percent",
  "product_image_urls",
  "variant_sku",
  "variant_name",
  "variant_group",
  "variant_value",
  "pack_label",
  "pack_size",
  "weight_value",
  "weight_unit_symbol",
  "mrp",
  "selling_price",
  "currency",
  "variant_image_urls",
  "is_default",
  "status",
  "block_mrp",
  "notes",
];

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const importV2Service = {
  async downloadSample() {
    const token = getAuthToken?.() || "";
    const res = await fetch(`${env.CATALOG_BASE_URL}/api/admin/import-v2/sample`, {
      method: "GET",
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    if (!res.ok) {
      let message = "Sample download failed";
      try {
        const json = await res.json();
        message = json?.message || json?.error || message;
      } catch {
        // ignore non-json error body
      }
      throw new Error(message);
    }

    const blob = await res.blob();
    downloadBlob(blob, "bulk-product-import-v2-sample.xlsx");
  },

  async uploadExcel(file) {
    if (!file) throw new Error("File is required");
    const formData = new FormData();
    formData.append("file", file);
    return api.post("/api/admin/import-v2/excel", formData);
  },

  async preview(jobId, params = {}) {
    if (!jobId) throw new Error("jobId is required");
    return api.get(`/api/admin/import-v2/jobs/${jobId}/preview`, { params });
  },

  async updateRows(jobId, rows = []) {
    if (!jobId) throw new Error("jobId is required");
    return api.patch(`/api/admin/import-v2/jobs/${jobId}/rows`, { rows });
  },

  async commit(jobId, payload = {}) {
    if (!jobId) throw new Error("jobId is required");
    return api.post(`/api/admin/import-v2/jobs/${jobId}/commit`, payload);
  },
};
